import React, { useState, useEffect } from 'react';
import Globals from '../contexts/Globals';
import I18nLib from '../lib/I18nLib';
import LoaderButton from './LoaderButton';
import RedeemCode from './account/RedeemCode';

function Club(props) {
	
	let globals = Globals.useContainer();
	let i18n = I18nLib.init(globals);
	let club = props.club;
	let xsollaUserId = props.xsollaUserId;
	let [showRedeemCode, setShowRedeemCode] = useState(false);
	let [isRedeemCodeMounted, setIsRedeemCodeMounted] = useState(false);
	const containerRef = React.useRef(null);
	const contentRef = React.useRef(null);
	
	useEffect(() => {
		let showTimer = null;
		
		if(showRedeemCode){
			setIsRedeemCodeMounted(true);
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					if(containerRef.current && contentRef.current){
						const height = Math.max(
							contentRef.current.scrollHeight,
							contentRef.current.offsetHeight,
							contentRef.current.getBoundingClientRect().height
						);
						const computedStyle = window.getComputedStyle(contentRef.current);
						const marginTop = parseFloat(computedStyle.marginTop) || 0;
						const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
						const totalHeight = height + marginTop + marginBottom + 20;
						containerRef.current.style.setProperty('--content-height', `${totalHeight}px`);
						containerRef.current.classList.remove('hide', 'shown');
						containerRef.current.classList.add('show');
						
						showTimer = setTimeout(() => {
							if(containerRef.current){
								containerRef.current.classList.remove('show');
								containerRef.current.classList.add('shown');
								containerRef.current.style.removeProperty('--content-height');
							}
						}, 300);
					}
				});
			});
		} else {
			if(containerRef.current && contentRef.current){
				const height = Math.max(
					contentRef.current.scrollHeight,
					contentRef.current.offsetHeight,
					contentRef.current.getBoundingClientRect().height
				);
				const computedStyle = window.getComputedStyle(contentRef.current);
				const marginTop = parseFloat(computedStyle.marginTop) || 0;
				const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
				const totalHeight = height + marginTop + marginBottom + 20;
				containerRef.current.style.setProperty('--content-height', `${totalHeight}px`);
				
				const currentMaxHeight = window.getComputedStyle(containerRef.current).maxHeight;
				
				// Log current classes
				if(currentMaxHeight === 'none'){
					containerRef.current.classList.remove('shown');
					containerRef.current.classList.add('show');
					void containerRef.current.offsetHeight;
					
					setTimeout(() => {
						requestAnimationFrame(() => {
							if(containerRef.current){
								containerRef.current.classList.remove('show');
								containerRef.current.classList.add('hide');
							}
						});
					}, 50);
				} else {
					requestAnimationFrame(() => {
						if(containerRef.current){
							containerRef.current.classList.remove('show', 'shown');
							containerRef.current.classList.add('hide');
						}
					});
				}
			}
			const hideTimer = setTimeout(() => {
				setIsRedeemCodeMounted(false);
			}, 300);
			return () => {
				if(showTimer) clearTimeout(showTimer);
				clearTimeout(hideTimer);
			};
		}
		
		return () => {
			if(showTimer) clearTimeout(showTimer);
		};
	}, [showRedeemCode]);
	
	const handleCloseRedeemCode = () => {
		setShowRedeemCode(false);
	};
	
	return (
		<div className={`clubs-container ${props.isLast ? '' : 'gap-after'}`}>
			<div className={`club-cell sub-panel${props.center?' flex-row-center':''}`} style={{flexDirection: 'column'}}>
				<div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
					<div className="club-shield-container">
						<div className={(club.logoImageURL ? ''
							: 'show-placeholder') + " club-logo center-div"} style={{backgroundImage:club.logoImageURL ? `url(https://dhndi3mnxrz0u.cloudfront.net/v1/images?imageUrl=${encodeURIComponent(club.logoImageURL)}&size=128&mode=cover)` : 'none'}}>
						</div>
					</div>
					<div className="club-name-container">
						<h4 className="club-name">
							{club.name}
						</h4>
						<div className="club-level-container">
							<div className="club-level-text">{i18n('account.club-level','Level')}</div>
							<div className="club-level">{club.level}</div>
						</div>
					</div>
				</div>
				<div style={{display: 'flex', gap: '0.5rem', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center', marginTop: '0.5rem'}}>
					{xsollaUserId && globals.isXsollaAvailable && (
						<LoaderButton
							onClick={() => window.open(`${globals.sportConfig.xsollaWebstore}?user-id=${xsollaUserId}`)}
							className="xs"
						>
							Go to webstore
						</LoaderButton>
					)}
					<button
						className="loader-button xs"
						onClick={() => setShowRedeemCode(!showRedeemCode)}
						type="button"
					>
						{i18n('redeem-code.button','Redeem Code')}
					</button>
				</div>
				<div ref={containerRef} className={`redeem-code-container`}>
					<div ref={contentRef}>
						{isRedeemCodeMounted && (
							<RedeemCode clubId={club.id} onClose={handleCloseRedeemCode} />
						)}
					</div>
				</div>
			</div>
		</div>
	);
	
}

export default Club;